import api from './api';

const PATH = '/locations';

const list = () => api.get(PATH);

export const LocationsService = {
  list
}